<template>
  <div class="carousel-container" :style="{ maxWidth: maxWidth + 'px' }">
    <div class="carousel">
      <div class="carousel__wrapper" ref="carouselWrapper">
        <div class="carousel__header">
          <div class="carousel__headline">
            <slot name="header"></slot>
          </div>
          <div class="carousel__controls">
            <button @click="scrollPrev" :class="{ disabled: isAtStart }" class="carousel__arrow arrow-prev">
              <font-awesome-icon :icon="['fas', 'caret-left']" size="2x" fixed-width />
            </button>
            <button @click="scrollNext" :class="{ disabled: isAtEnd }" class="carousel__arrow arrow-next">
              <font-awesome-icon :icon="['fas', 'caret-right']" size="2x" fixed-width />
            </button>
          </div>
        </div>
        <ul
          ref="carouselContent"
          @mousedown="onMouseDown"
          @mousemove="onMouseMove"
          @mouseup="onMouseUp"
          @mouseleave="onMouseUp"
          @scroll="toggleArrows"
          class="carousel__content"
        >
          <!-- Must be a li element -->
          <slot></slot>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  props: {
    maxCustomWidth: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      screenWidth: window.innerWidth,
      isDragging: false,
      startX: 0,
      scrollStartX: 0,
      isAtStart: true,
      isAtEnd: false
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)

    this.$nextTick(() => {
      this.checkIfScrollable()
      this.toggleArrows()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    maxWidth() {
      if (this.maxCustomWidth) return this.maxCustomWidth
      if (this.screenWidth < 768) return this.screenWidth - 200

      return this.screenWidth - 230
    }
  },
  methods: {
    handleResize () {
      this.screenWidth = window.innerWidth
    },
    scrollNext() {
      const el = this.$refs.carouselContent
      const scrollAmount = el.clientWidth / 2
      el.scrollBy({ left: scrollAmount, behavior: 'smooth' })
    },
    scrollPrev() {
      const el = this.$refs.carouselContent
      const scrollAmount = el.clientWidth / 2
      el.scrollBy({ left: -scrollAmount, behavior: 'smooth' })
    },
    onMouseDown(e) {
      if (e.button !== 0) return

      const el = this.$refs.carouselContent
      this.isDragging = true
      this.startX = e.pageX - el.offsetLeft
      this.scrollStartX = el.scrollLeft
      el.classList.add('dragging')
    },
    onMouseMove(e) {
      if (!this.isDragging) return
      const el = this.$refs.carouselContent
      const x = e.pageX - el.offsetLeft
      const walk = this.startX - x
      el.scrollLeft = this.scrollStartX + walk
    },
    onMouseUp() {
      const el = this.$refs.carouselContent
      this.isDragging = false
      el.classList.remove('dragging')
      this.toggleArrows()
    },
    toggleArrows() {
      const el = this.$refs.carouselContent
      const maxScroll = el.scrollWidth - el.clientWidth
      const scrollLeft = el.scrollLeft

      this.isAtStart = scrollLeft < 10
      this.isAtEnd = scrollLeft >= maxScroll - 10
    },
    checkIfScrollable() {
      const wrapper = this.$refs.carouselWrapper
      const content = this.$refs.carouselContent

      if (!wrapper || !content) return

      if (content.scrollWidth > content.clientWidth) {
        wrapper.classList.add('has-arrows')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.carousel-container {
  margin: 0 auto;
}

.carousel {

  h2 { margin: 0; }

  .dragging {
    .card-indicator { pointer-events: none; }
  }

  .carousel__header {
    display: grid;
    grid-auto-flow: column;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 8px;
  }

  .carousel__content {
    overflow-y: hidden;
    overflow-x: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    display: grid;
    // -webkit-overflow-scrolling: touch;
    cursor: grab;
    padding: 0;
    margin: 0;
    grid-gap: 24px;
    grid-auto-flow: column;
    list-style: none;
    padding: 1rem;

    &::-webkit-scrollbar {
      display: none;
    }

    &.dragging {
      cursor: grabbing;
      user-select: none;
      scroll-behavior: auto !important;
    }
  }

  .carousel__controls {
    margin-top: 10px;
    display: grid;
    grid-auto-flow: column;
    grid-gap: 24px;
  }

  .carousel__arrow {
    padding: 0;
    background: transparent;
    box-shadow: none;
    border: 0;
  }

  .carousel__arrow.disabled {
    opacity: 0.4;
    pointer-events: none;

    &::before {
      filter: brightness(2);
    }
  }

  .carousel__wrapper.has-arrows .carousel__controls {
    display: flex;
  }
}
</style>
